import { render, staticRenderFns } from "./DatasetCrud.vue?vue&type=template&id=5eeea634&scoped=true"
import script from "./DatasetCrud.vue?vue&type=script&lang=js"
export * from "./DatasetCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeea634",
  null
  
)

export default component.exports